/* eslint-disable */

export default class TrackerExactSuccess {
  static enviar(acao) {
    /* eslint no-undef: "off" */
    // IntegracaoCS.Enviar(acao);
  }
}
